module.exports = __webpack_public_path__ + "static/media/tenancy-m.789e1363.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Services/tenancy-m.jpg
// module id = 87
// module chunks = 0